import { InputRule, inputRules } from "prosemirror-inputrules";
import type { Plugin } from "prosemirror-state";
import { normalizeUrl } from "./commands";
import { textSchema } from "./schema";

/**
 * Spec §8 — typing a URL followed by a space turns it into a link. Built on
 * prosemirror-inputrules (the platform's input-rule mechanism); the rule
 * only fires when the URL is not already inside a link.
 */
const URL_THEN_SPACE = /(^|\s)((?:https?:\/\/|www\.)[^\s<>"']+)\s$/i;

const autolinkRule = new InputRule(
  URL_THEN_SPACE,
  (state, match, start, end) => {
    const url = match[2];
    const urlStart = start + match[1].length;
    const urlEnd = urlStart + url.length;
    const { link } = textSchema.marks;
    if (link.isInSet(state.doc.resolve(urlStart + 1).marks())) return null;
    return state.tr
      .insertText(" ", end)
      .addMark(
        urlStart,
        urlEnd,
        link.create({ href: normalizeUrl(url), target: "_blank" }),
      );
  },
);

export const autolinkPlugin = (): Plugin =>
  inputRules({ rules: [autolinkRule] });
